class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    // 添加新的选择器
    this.addToCartButton = document.getElementById('add-to-cart-drawer');
    this.productSelector = document.getElementById('product-selector');
    
    // 绑定新的事件
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }
    
    // 初始化免费产品设置（将在 DOMContentLoaded 时从主题设置中配置）
    this.freeProductSettings = {
      enabled: false // 默认禁用，等待主题设置配置
    };

    // 监听购物车更新事件
    this.setupCartUpdateListener();
  }

  setupCartUpdateListener() {
    // 监听 PUB_SUB_EVENTS.cartUpdate 事件
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        //console.log('🔄 购物车更新事件触发:', event);
        
        // 检查是否是免费产品更新，避免无限循环
        if (event.source === 'free-product-auto-add') {
          //console.log('⏭️ 跳过免费产品自动添加事件');
          return;
        }
        
        // 延迟检查，确保购物车状态已更新
        setTimeout(() => {
          // 对于产品表单添加的情况，总是重新获取最新的购物车数据
          if (event.source === 'product-form') {
            //console.log('🛒 产品表单添加商品，重新获取完整购物车数据');
            this.fetchCartAndCheck();
          } else if (event.cartData) {
            //console.log('🧮 使用事件中的购物车数据进行检查');
            this.checkAndAddFreeProduct(event.cartData);
          } else {
            // 如果没有 cartData，重新获取购物车信息
            //console.log('🔄 重新获取购物车数据');
            this.fetchCartAndCheck();
          }
        }, 300);
      });
      
      //console.log('✅ 购物车更新监听器已设置');
    } else {
      console.warn('⚠️ 发布订阅系统不可用，将使用备用监听方法');
      // 备用方案：监听DOM变化
      this.setupFallbackListener();
    }
  }

  setupFallbackListener() {
    // 备用方案：监听购物车图标的变化来检测购物车更新
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      const observer = new MutationObserver(() => {
        //console.log('🔄 检测到购物车图标变化，执行检查');
        setTimeout(() => {
          this.fetchCartAndCheck();
        }, 300);
      });
      
      observer.observe(cartIcon, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      this.cartIconObserver = observer;
      //console.log('✅ 备用购物车监听器已设置');
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.cartIconObserver) {
      this.cartIconObserver.disconnect();
    }
  }

  fetchCartAndCheck() {
    //console.log('🔄 正在获取最新购物车数据...');
    
    fetch(`${window.routes.cart_url}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cartData => {
        //console.log('📊 获取到的购物车数据:', cartData);
        //console.log(`📈 购物车商品数量: ${cartData.item_count || 0}`);
        //console.log(`💰 购物车总金额: €${(cartData.total_price || 0)/100}`);
        
        if (cartData.total_price !== undefined) {
          this.checkAndAddFreeProduct(cartData);
        } else {
          console.error('❌ 购物车数据缺少 total_price 字段');
          // 尝试使用备用 API
          this.fetchCartDataAlternative();
        }
      })
      .catch(error => {
        console.error('获取购物车数据失败:', error);
        // 尝试使用备用方法
        this.fetchCartDataAlternative();
      });
  }

  fetchCartDataAlternative() {
    //console.log('🔄 尝试备用购物车数据获取方法...');
    
    // 尝试从购物车页面获取数据
    fetch(`${window.routes.cart_url}`)
      .then(response => response.text())
      .then(html => {
        // 从页面中提取购物车数据
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // 尝试从页面中找到购物车数据
        const scriptTags = doc.querySelectorAll('script');
        let cartData = null;
        
        scriptTags.forEach(script => {
          const content = script.textContent;
          if (content.includes('cart') && content.includes('total_price')) {
            try {
              // 尝试提取 JSON 数据
              const match = content.match(/cart.*?=.*?({.*?})/);
              if (match) {
                cartData = JSON.parse(match[1]);
              }
            } catch (e) {
              // 忽略解析错误
            }
          }
        });
        
        if (cartData && cartData.total_price !== undefined) {
          //console.log('✅ 通过备用方法获取到购物车数据');
          this.checkAndAddFreeProduct(cartData);
        } else {
          console.error('❌ 备用方法也无法获取有效的购物车数据');
        }
      })
      .catch(error => {
        console.error('备用购物车数据获取失败:', error);
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // 添加新的购物车添加方法
  async handleAddToCart(event) {
    const button = event.target;
    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    const variantId = button.dataset.variantId;
    
    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      const data = await response.json();

      if (response.ok) {
        //console.log('✅ 商品已添加到购物车');
        
        // 获取最新的购物车数据
        const cartResponse = await fetch('?section_id=cart-drawer');
        const cartHTML = await cartResponse.text();
        
        // 更新购物车内容
        const parsedCart = {
          sections: {
            'cart-drawer': cartHTML,
            'cart-icon-bubble': await (await fetch('?section_id=cart-icon-bubble')).text()
          }
        };
        
        this.renderContents(parsedCart);
        
        // 更新购物车计数
        this.updateCartCount();
        
        // 检查免费产品（延迟执行确保购物车已更新）
        setTimeout(() => {
          this.fetchCartAndCheck();
        }, 300);
        
      } else {
        console.error('添加商品失败:', data.description);
      }
    } catch (error) {
      console.error('添加商品出错:', error);
    } finally {
      button.classList.remove('loading');
    }
  }

  // 添加购物车计数更新方法
  updateCartCount(cartData) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          const cartCount = bubble.querySelector('span[aria-hidden="true"]');
          if (cartCount) cartCount.textContent = cart.item_count;
          
          const cartCountAccessible = bubble.querySelector('.visually-hidden');
          if (cartCountAccessible) {
            cartCountAccessible.textContent = cart.item_count === 1 
              ? window.accessibilityStrings.oneCartCount 
              : window.accessibilityStrings.otherCartCount.replace('[count]', cart.item_count);
          }
        });
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // 检查是否需要添加免费产品
    if (parsedState.total_price !== undefined || parsedState.items) {
      this.checkAndAddFreeProduct(parsedState);
    }

    setTimeout(() => {
      // 重新绑定关闭按钮事件
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /**
   * 检查购物车总金额，如果达到阈值则自动添加免费产品
   */
  checkAndAddFreeProduct(cartData) {
    // 检查免费产品功能是否启用
    if (!this.freeProductSettings.enabled) {
      //console.log('🚫 免费产品功能已禁用');
      return;
    }
    
    // 检查是否选择了免费产品
    if (!this.freeProductSettings.freeProduct) {
      console.warn('⚠️ 未在主题设置中选择免费产品，请前往后台设置');
      return;
    }
    
    if (!this.freeProductSettings.freeProductVariantId) {
      console.warn('⚠️ 免费产品没有可用的变体');
      return;
    }

    //console.log('🔍 检查购物车数据:', cartData);
    
    // 尝试多种方式获取购物车总金额
    let cartTotal = 0;
    
    if (cartData.total_price !== undefined) {
      cartTotal = cartData.total_price;
    } else if (cartData.items && cartData.items.length > 0) {
      // 如果没有 total_price，手动计算总金额
      cartTotal = cartData.items.reduce((total, item) => {
        return total + (item.final_line_price || item.line_price || (item.price * item.quantity));
      }, 0);
      //console.log('🧮 手动计算购物车总金额:', cartTotal);
    }
    
    const threshold = this.freeProductSettings.thresholdAmount;
    
    //console.log(`购物车检查 - 总金额: €${cartTotal/100}, 阈值: €${threshold/100}`);
    
    // 如果购物车数据不完整，重新获取完整数据
    if (cartTotal === 0 && cartData.items && cartData.items.length > 0) {
      //console.log('⚠️ 购物车数据不完整，重新获取...');
      this.fetchCartAndCheck();
      return;
    }
    
    // 检查购物车中是否已经有免费产品（检查所有变体）
    const hasFreeProduct = cartData.items && cartData.items.some(item => {
      const itemVariantId = item.variant_id.toString();
      
      // 检查是否匹配当前配置的变体ID
      if (itemVariantId === this.freeProductSettings.freeProductVariantId.toString()) {
        return true;
      }
      
      // 检查是否匹配免费产品的任何变体
      if (this.freeProductSettings.freeProduct && this.freeProductSettings.freeProduct.variants) {
        return this.freeProductSettings.freeProduct.variants.some(variant => 
          variant.id.toString() === itemVariantId
        );
      }
      
      return false;
    });

    //console.log(`免费产品状态 - 存在: ${hasFreeProduct}, 应该添加: ${cartTotal >= threshold}`);

    // 如果达到阈值且没有免费产品，则添加
    if (cartTotal >= threshold && !hasFreeProduct) {
      //console.log('正在添加免费产品...');
      this.addFreeProductToCart();
    } 
    // 如果未达到阈值但有免费产品，则移除
    else if (cartTotal < threshold && hasFreeProduct) {
      //console.log('正在移除免费产品...');
      this.removeFreeProductFromCart(cartData);
    }
  }

  /**
   * 刷新购物车显示
   */
  refreshCartDisplay() {
    fetch(`${window.routes.cart_url}.js`)
      .then(response => response.json())
      .then(cartData => {
        // 获取当前购物车的完整数据
        fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newCartDrawer = html.querySelector('cart-drawer');
            if (newCartDrawer) {
              const sections = newCartDrawer.innerHTML;
              this.querySelector('.drawer__inner').innerHTML = sections;
            }
          })
          .catch(error => {
            console.error('Error refreshing cart display:', error);
          });
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  /**
   * 选择最佳的免费产品变体
   */
  getBestFreeProductVariant() {
    const product = this.freeProductSettings.freeProduct;
    if (!product || !product.variants) {
      return this.freeProductSettings.freeProductVariantId;
    }
    
    // 优先选择价格为0且有库存的变体
    const freeVariant = product.variants.find(variant => 
      variant.price === 0 && variant.available
    );
    
    if (freeVariant) {
      //console.log(`✅ 选择免费变体: ${freeVariant.title} (ID: ${freeVariant.id})`);
      return freeVariant.id.toString();
    }
    
    // 如果没有免费变体，选择第一个可用变体
    const availableVariant = product.variants.find(variant => variant.available);
    if (availableVariant) {
      //console.log(`⚠️ 使用可用变体: ${availableVariant.title} (ID: ${availableVariant.id}, 价格: €${availableVariant.price/100})`);
      return availableVariant.id.toString();
    }
    
    // 最后选择第一个变体
    //console.log(`⚠️ 使用默认变体: ${product.firstVariantId}`);
    return product.firstVariantId.toString();
  }

  /**
   * 添加免费产品到购物车
   */
  addFreeProductToCart() {
    const variantId = this.getBestFreeProductVariant();
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', this.getSectionsToRender().map(section => section.id));
    formData.append('sections_url', window.location.pathname);

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    };

    fetch(window.routes.cart_add_url, config)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // 检查响应类型
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('响应不是 JSON 格式');
        }
        
        return response.json();
      })
      .then(response => {
        if (response.status) {
          console.error('Error adding free product:', response.errors || response.description);
          return;
        }
        
        // 显示通知消息
        this.showFreeProductNotification(true);
        
        // 发布购物车更新事件，标记为免费产品添加
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'free-product-auto-add',
            cartData: response,
            variantId: this.freeProductSettings.freeProductVariantId
          });
        }
        
        // 更新购物车内容
        this.renderContents(response);
      })
      .catch(error => {
        console.error('Error adding free product:', error);
        
        // 如果添加失败，尝试刷新购物车显示
        this.refreshCartDisplay();
      });
  }

  /**
   * 从购物车中移除免费产品
   */
  removeFreeProductFromCart(cartData) {
    // 查找免费产品（检查所有变体）
    const freeProductItem = cartData.items.find(item => {
      const itemVariantId = item.variant_id.toString();
      
      // 检查是否匹配当前配置的变体ID
      if (itemVariantId === this.freeProductSettings.freeProductVariantId.toString()) {
        return true;
      }
      
      // 检查是否匹配免费产品的任何变体
      if (this.freeProductSettings.freeProduct && this.freeProductSettings.freeProduct.variants) {
        return this.freeProductSettings.freeProduct.variants.some(variant => 
          variant.id.toString() === itemVariantId
        );
      }
      
      return false;
    });
    
    if (!freeProductItem) {
      //console.log('未找到要移除的免费产品');
      return;
    }

    //console.log('找到免费产品:', freeProductItem);
    
    // 获取正确的 line 参数 - 在 Shopify 中通常是商品在购物车中的索引位置（从1开始）
    const lineIndex = cartData.items.findIndex(item => 
      item.variant_id.toString() === this.freeProductSettings.freeProductVariantId.toString()
    ) + 1; // Shopify 的 line 参数从1开始

    //console.log('移除商品 line 索引:', lineIndex);

    const body = JSON.stringify({
      line: lineIndex,
      quantity: 0,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    });

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: body
    };

    //console.log('发送移除请求:', { line: lineIndex, quantity: 0 });

    fetch(window.routes.cart_change_url, config)
      .then(response => {
        if (!response.ok) {
          console.error('移除请求失败 - 状态码:', response.status);
          // 尝试获取错误详情
          return response.text().then(text => {
            console.error('错误响应内容:', text);
            throw new Error(`HTTP error! status: ${response.status}`);
          });
        }
        return response.text();
      })
      .then(state => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error('Invalid JSON response:', state);
          throw new Error('响应不是有效的 JSON');
        }
        
        if (parsedState.errors) {
          console.error('Error removing free product:', parsedState.errors);
          return;
        }
        
        //console.log('免费产品移除成功');
        
        // 显示通知消息
        this.showFreeProductNotification(false);
        
        // 发布购物车更新事件，标记为免费产品移除
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'free-product-auto-add',
            cartData: parsedState,
            variantId: this.freeProductSettings.freeProductVariantId
          });
        }
        
        // 更新购物车内容
        this.renderContents(parsedState);
      })
      .catch(error => {
        console.error('Error removing free product:', error);
        
        // 如果移除失败，尝试使用替代方法
        this.removeFreeProductAlternative(cartData);
      });
  }

  /**
   * 备用的移除免费产品方法
   */
  removeFreeProductAlternative(cartData) {
    //console.log('尝试使用备用移除方法...');
    
    const freeProductItem = cartData.items.find(item => 
      item.variant_id.toString() === this.freeProductSettings.freeProductVariantId.toString()
    );
    
    if (!freeProductItem) return;

    // 使用 FormData 而不是 JSON
    const formData = new FormData();
    const lineIndex = cartData.items.findIndex(item => 
      item.variant_id.toString() === this.freeProductSettings.freeProductVariantId.toString()
    ) + 1;
    
    formData.append('line', lineIndex);
    formData.append('quantity', '0');
    formData.append('sections', this.getSectionsToRender().map(section => section.id));
    formData.append('sections_url', window.location.pathname);

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    fetch(window.routes.cart_change_url, config)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(state => {
        const parsedState = JSON.parse(state);
        //console.log('备用方法移除成功');
        
        // 显示通知消息
        this.showFreeProductNotification(false);
        
        // 发布购物车更新事件，标记为免费产品移除
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'free-product-auto-add',
            cartData: parsedState,
            variantId: this.freeProductSettings.freeProductVariantId
          });
        }
        
        // 更新购物车内容
        this.renderContents(parsedState);
      })
      .catch(error => {
        console.error('备用移除方法也失败:', error);
        // 最后尝试刷新购物车显示
        this.refreshCartDisplay();
      });
  }

  /**
   * 显示免费产品添加/移除的通知
   */
  showFreeProductNotification(added) {
    const message = added 
      ? this.freeProductSettings.addMessage 
      : this.freeProductSettings.removeMessage;
    
    // 创建通知元素
    const notification = document.createElement('div');
    notification.className = 'free-product-notification';
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${added ? '#4CAF50' : '#FF9800'};
      color: white;
      padding: 15px 20px;
      border-radius: 5px;
      z-index: 10000;
      font-size: 14px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      transition: opacity 0.3s ease;
    `;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    // 3秒后自动移除通知
    setTimeout(() => {
      notification.style.opacity = '0';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }

  /**
   * 设置免费产品配置
   * @param {Object} settings - 配置对象
   * @param {number} settings.thresholdAmount - 阈值金额（以分为单位）
   * @param {string} settings.freeProductVariantId - 免费产品变体ID
   * @param {string} settings.freeProductHandle - 免费产品handle
   */
  setFreeProductSettings(settings) {
    this.freeProductSettings = { ...this.freeProductSettings, ...settings };
    
    // 显示当前配置信息
    if (!settings.enabled) {
      if (!settings.freeProduct) {
        //console.log('⚠️ 免费产品功能未配置 - 请在主题设置中选择免费产品');
      } else {
        //console.log('🚫 免费产品功能已在主题设置中禁用');
      }
    } else if (settings.freeProduct) {
      //console.log(`📦 免费产品配置已更新:`);
      //console.log(`   • 功能状态: 启用`);
      //console.log(`   • 阈值金额: €${settings.thresholdAmount/100}`);
      //console.log(`   • 选中产品: ${settings.freeProduct.title}`);
      //console.log(`   • 产品ID: ${settings.freeProduct.id}`);
      //console.log(`   • 产品Handle: ${settings.freeProduct.handle}`);
      //console.log(`   • 默认变体ID: ${settings.freeProduct.firstVariantId}`);
      //console.log(`   • 可用变体数量: ${settings.freeProduct.variants.length}`);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// 初始化免费产品功能
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    // 从主题设置中读取免费产品配置（通过全局变量）
    const themeSettings = window.shopifyThemeSettings;
    const freeProduct = themeSettings?.freeProduct;
    
    const freeProductSettings = {
      enabled: themeSettings?.freeProductEnabled !== false && freeProduct !== null,
      thresholdAmount: themeSettings?.freeProductThreshold || 6000,
      freeProduct: freeProduct,
      freeProductVariantId: freeProduct?.firstVariantId || '44017187684488',
      freeProductHandle: freeProduct?.handle || 'juego-para-montar-puzzles-copy',
      addMessage: themeSettings?.freeProductAddMessage || '🎉 恭喜！您获得了一个免费产品！',
      removeMessage: themeSettings?.freeProductRemoveMessage || '免费产品已从购物车中移除'
    };
    
    // 配置免费产品设置
    cartDrawer.setFreeProductSettings(freeProductSettings);
    
    //console.log('✅ 购物车抽屉功能已完全初始化');
    //console.log('⚙️ 配置来源: Shopify 主题设置');
    //console.log('🛒 新增功能: 支持抽屉内直接添加商品 (#add-to-cart-drawer)');
    //console.log('🔧 调试命令:');
    //console.log('   • window.getCartItemIds() - 查看购物车信息');
    //console.log('   • window.testFreeProductFunction() - 测试功能');
    //console.log('   • window.removeFreeProduct() - 手动移除免费产品');
    //console.log('   • window.forceCartCheck() - 强制检查购物车');
    //console.log('🎯 功能特性:');
    //console.log('   • 产品页面添加商品 → 自动检查免费产品');
    //console.log('   • 抽屉内添加商品 → 自动检查免费产品');
    //console.log('   • 修改商品数量 → 自动检查免费产品');
    //console.log('   • 自动更新购物车计数和图标状态');
    //console.log('🎛️ 要修改设置，请前往 Shopify 后台 → 主题 → 自定义 → 主题设置 → 购物车设置');
  }
});

// 全局函数，方便在控制台或其他地方配置免费产品
window.setFreeProductConfig = function(thresholdAmount, variantId, handle) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.setFreeProductSettings({
      thresholdAmount: thresholdAmount,
      freeProductVariantId: variantId,
      freeProductHandle: handle
    });
    //console.log(`免费产品配置已更新 - 阈值: €${thresholdAmount/100}, 变体ID: ${variantId}`);
  } else {
    console.error('找不到购物车抽屉元素');
  }
};

// 获取购物车中所有商品的变体ID
window.getCartItemIds = function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      //console.log('🛒 购物车商品信息:');
      if (cart.items && cart.items.length > 0) {
        cart.items.forEach((item, index) => {
          //console.log(`Line ${index + 1}: ${item.product_title}`);
          //console.log(`   变体ID: ${item.variant_id}`);
          //console.log(`   Key: ${item.key}`);
          //console.log(`   价格: €${item.price / 100}`);
          //console.log(`   数量: ${item.quantity}`);
          //console.log('   ---');
        });
        //console.log(`💰 购物车总金额: €${cart.total_price / 100}`);
        
        // 检查免费产品
        const freeProductIndex = cart.items.findIndex(item => 
          item.variant_id.toString() === '44017187684488'
        );
        if (freeProductIndex !== -1) {
          //console.log(`🎁 免费产品位置: Line ${freeProductIndex + 1}`);
        }
      } else {
        //console.log('购物车为空');
      }
    })
    .catch(error => {
      console.error('获取购物车信息失败:', error);
    });
};

// 测试免费产品功能
window.testFreeProductFunction = function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        //console.log('🧪 测试免费产品功能...');
        cartDrawer.checkAndAddFreeProduct(cartData);
      })
      .catch(error => {
        console.error('测试失败:', error);
      });
  } else {
    console.error('找不到购物车抽屉元素');
  }
};

// 手动移除免费产品（调试用）
window.removeFreeProduct = function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        //console.log('🗑️ 手动移除免费产品...');
        cartDrawer.removeFreeProductFromCart(cartData);
      })
      .catch(error => {
        console.error('移除失败:', error);
      });
  } else {
    console.error('找不到购物车抽屉元素');
  }
};

// 强制刷新购物车检查（调试用）
window.forceCartCheck = function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    //console.log('🔄 强制执行购物车检查...');
    cartDrawer.fetchCartAndCheck();
  } else {
    console.error('找不到购物车抽屉元素');
  }
};
